// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".briq-time-input .time-picker {\n  display: block;\n  background-color: #fff;\n}\n.briq-time-input .time-picker:after {\n  content: '';\n  width: 17px;\n  height: 17px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n  position: absolute;\n  top: 11px;\n  right: 11px;\n}\n.briq-time-input .time-picker .clear-btn {\n  font-size: 1em;\n  padding: 0 0.7em;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
